import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, KeepAlive as _KeepAlive, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../public/static/logo.jpg'


const _withScopeId = n => (_pushScopeId("data-v-7ba3f3cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_header_top = _resolveComponent("header-top")!
  const _component_header_bottom = _resolveComponent("header-bottom")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.isDay? 'day': 'night')
  }, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_aside, { style: {"width":"auto"} }, {
          default: _withCtx(() => [
            _createVNode(_component_el_menu, {
              router: "",
              collapse: _ctx.isCollapse,
              "background-color": _ctx.isDay? '': '#2b2b2b',
              "text-color": _ctx.isDay? '': '#ffffff',
              "default-active": "2"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toHome && _ctx.toHome(...args))),
                  class: "logoTitle"
                }, [
                  _hoisted_1,
                  (!_ctx.isCollapse)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Invengo Auth"))
                    : _createCommentVNode("", true)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dirList, (item) => {
                  return (_openBlock(), _createBlock(_component_el_sub_menu, {
                    index: String(item.sort),
                    key: item.id
                  }, {
                    title: _withCtx(() => [
                      _createElementVNode("i", {
                        class: _normalizeClass(item.icon)
                      }, null, 2),
                      _createElementVNode("span", _hoisted_3, _toDisplayString(item.name), 1)
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (i) => {
                        return (_openBlock(), _createBlock(_component_el_menu_item, {
                          key: i.path,
                          index: String(i.path)
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("i", {
                              class: _normalizeClass(i.icon)
                            }, null, 2),
                            _createElementVNode("span", _hoisted_4, _toDisplayString(i.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["index"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["index"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["collapse", "background-color", "text-color"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_header, { height: "100px" }, {
              default: _withCtx(() => [
                _createVNode(_component_header_top, {
                  isDay: _ctx.isDay,
                  onSendDay: _ctx.sendDay,
                  isCollapse: _ctx.isCollapse,
                  onChildEvent: _ctx.open
                }, null, 8, ["isDay", "onSendDay", "isCollapse", "onChildEvent"]),
                (_openBlock(), _createBlock(_KeepAlive, null, [
                  _createVNode(_component_header_bottom, { isDay: _ctx.isDay }, null, 8, ["isDay"])
                ], 1024))
              ]),
              _: 1
            }),
            _createVNode(_component_el_main, null, {
              default: _withCtx(() => [
                _createVNode(_component_router_view, null, {
                  default: _withCtx(({ Component }) => [
                    _createVNode(_Transition, null, {
                      default: _withCtx(() => [
                        (_openBlock(), _createBlock(_KeepAlive, null, [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                        ], 1024))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 2))
}